import React from 'react';
import "@mobiscroll/react/dist/css/mobiscroll.react.min.css";
import { Eventcalendar, MbscCalendarEvent, MbscEventcalendarView, Popup } from '@mobiscroll/react';
import Popover from '@mui/material/Popover';
import useStore from '../../store/useStore';
import { Link } from 'react-router-dom';
import StatementCardEvents from './StatementCardEvents';
import { Information } from '@carbon/icons-react';
import { bgcolor } from '@mui/system';

const CalendarViewEvents = () => {

  const { eventData } = useStore((state: any) => ({ eventData: state.MUIdataEvents.rows }));
  const { datasource } = useStore((state: any) => ({ datasource: state.settings.params.datasource }));
  const { types } = useStore((state: any) => ({ types: state.types }));

  const [isOpen, setOpen] = React.useState<boolean>(false);
  const [anchor, setAnchor] = React.useState<any>(null);
  const [currentEvent, setCurrentEvent] = React.useState<any>([]);
  const timerRef = React.useRef<any>(null);
  const [myEvents, setEvents] = React.useState<MbscCalendarEvent[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<any | null>(null);

  React.useEffect(() => {
    const newEvents = [];

    for (const value of eventData) {
      newEvents.push({
        start: value.Start,
        end: value.End || '',
        title: value.Title,
        color: getColorForType(value.Type), //'#' + Math.floor(Math.random() * 16777215).toString(16),
        id: value.EventId
      });
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    setEvents(newEvents);

  }, [eventData]);

  const getColorForType = (eventType: string) => {
    switch (eventType) {
      case 'Study group':
        return '#FEC829';
      case 'Conference':
        return '#305FA7';
      case 'Council':
        return '#C68BDC';
      case 'Symposia':
      case 'Symposium':
        return '#A1CF60';
      case 'Trainings':
        return '#FA4D55';
      case 'RDF':
        return '#C3893D';
      case 'Seminar':
      case 'Forum':
      case 'Workshop':
        return '#277051';
      case 'Meeting':
        return '#FF8672';
      case 'External ITU-related':
        return '#AF4FC5';
      case 'CWG':
        return '#DCA26D';
      case 'Advisory group':
        return '#3D3A60';
      case 'RPM':
      case 'CPM':
      case 'Inter':
      case 'Regional':
        return '#6C9F88';
      case 'Other':
        return '#B4B4B4';
      case 'Rapporteur group':
        return '#CE372F';
      case 'Working party':
        return '#FE29F6';
      default:
        return '#' + Math.floor(Math.random() * 16777215).toString(16); // random color
    }
  }

  const view = React.useMemo<MbscEventcalendarView>(() => {
    return {
      calendar: { labels: 'all' }
    };
  }, []);

  const onEventClick = React.useCallback((args: any) => {
    const event = args.event;
    const dataEvent = eventData.filter((d: any) => d.EventId === event.id)[0];
    setCurrentEvent(dataEvent);
    setAnchor(args.domEvent.target);
    setOpen(true);
  }, []);

  const onMouseEnter = React.useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);

  const onEventHoverOut = React.useCallback(() => {
    timerRef.current = setTimeout(() => { setOpen(false); }, 200);
  }, []);

  const onMouseLeave = React.useCallback(() => {
    timerRef.current = setTimeout(() => { setOpen(false); }, 200);
  }, []);

  const handleClickColorKeysPopup = (event: React.MouseEvent<React.ReactSVGElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="ituContainer">
      <div className="calendar-wrapper">
        <Information className="info-icon" onClick={handleClickColorKeysPopup}/>
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
        <div className="colour-keys-popup">
          <div className="h6">Colour key</div>
          {types.map((type: string) => {
            let color = getColorForType(type);
            return (
              <div key={type}>
                <div className="dot" style={{ backgroundColor:`${color}` }}></div><div>{type}</div>
              </div>  
            )
            })
          }
        </div>
      </Popover>
        <Eventcalendar
          theme="ios"
          themeVariant="light"
          controls={['calendar']}
          clickToCreate={false}
          dragToCreate={false}
          dragToMove={false}
          dragToResize={false}
          eventDelete={false}
          data={myEvents}
          view={view}
          onEventClick={onEventClick}
          onEventHoverOut={onEventHoverOut}
        />
        <Popup
          display="anchored"
          isOpen={isOpen}
          anchor={anchor}
          touchUi={false}
          showOverlay={false}
          contentPadding={false}
          closeOnOverlayClick={false}
          width={400}
          cssClass="md-tooltip"
        >
          <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <a href={currentEvent.EventURL} target="_blank" rel="noreferrer">
              <StatementCardEvents key={currentEvent.id} data={currentEvent} datasource={datasource} />
            </a>
          </div>
        </Popup>
      </div>
    </div>
  );
};

export default CalendarViewEvents;